export const FR = {
    HOME_PATH: '/',
    HOW_IT_WORK_PATH: '/offres-du-moment',
    FAQ_PATH: '/faq',
    LEGAL_NOTICE_PATH: '/mentions-legales',
    TERMS_PATH: '/conditions-generales-utilisation',
    TERMS_OF_SALES: '/conditions-generales-vente',
    CONTACTREQUEST_PATH: '/service-client',
    UNSUBSCRIBE_PATH: '/desabonnement',
    TOOLBAR_PATH: '/alerte-bons-plans',
    TOOLBAR_POST_INSTALL_PATH: '/toolbar/post-install',
    MOBILE_APP_PATH: '/appli_mobile',

    ACCOUNT_PATH: '/compte',
    ACCOUNT_JACKPOT_PATH: '/compte/cagnotte-cashback',
    ACCOUNT_MESSAGES_PATH: '/compte/mes-messages',
    ACCOUNT_EBONS_PATH: '/compte/mes-bons-d-achat',
    ACCOUNT_PROFILE_PATH: '/compte/mon-profil',

    ONLINE: 'en-ligne',
    OFFLINE: 'en-magasin',
    EBON: 'bon-achat',

    INTERSTITIEL_CASHBACK_PATH: '/interstitiel/cashback/',
    INTERSTITIEL_TOOLBAR_CASHBACK_PATH: '/toolbar/interstitiel/cashback/',
    INTERSTITIEL_REDUCTION_PATH: '/interstitiel/code-promo/',
    INTERSTITIEL_TOOLBAR_REDUCTION_PATH: '/toolbar/interstitiel/code-promo/',

    MERCHANTPAGE_PATH: '/cashback/fiche/',
    MERCHANTPAGE_TYPE_PATH: '/cashback/fiche/:type/',
    MERCHANTPAGE_ONLINE_PATH: '/cashback/fiche/en-ligne/',
    MERCHANTPAGE_EBON_PATH: '/cashback/fiche/bon-achat/',
    MERCHANTPAGE_OFFLINE_PATH: '/cashback/fiche/en-magasin/',

    FLASHING_TICKET_PATH: '/envoi-ticket',

    ALO_PATH: '/synchronisation-compte-bancaire',
    ALO_CONFIRMATION_PATH: '/confirmation-synchronisation',

    CASHBACK_PATH: '/cashback',
    REDUCTION_PATH: '/reduction',
    CASHBACK_ONLINE: '/cashback/en-ligne',
    CASHBACK_EBON: '/cashback/bon-achat',
    CASHBACK_OFFLINE: '/cashback/en-magasin',
    CASHBACK_MOST_POPULAR: '/cashback/les-plus-populaires',

    CASHBACK_TYPE_MOST_POPULAR_PATH: '/cashback/:type/les-plus-populaires',
    CASHBACK_TYPE_ALPHA_PATH: '/cashback/:type/alphabetique/',
    CASHBACK_TYPE_CATEGORY_PATH: '/cashback/:type/categorie/',

    CASHBACK_ONLINE_MOST_POPULAR_PATH: '/cashback/en-ligne/les-plus-populaires',
    CASHBACK_ONLINE_ALPHA_PATH: '/cashback/en-ligne/alphabetique/',
    CASHBACK_ONLINE_CATEGORY_PATH: '/cashback/en-ligne/categorie/',

    CASHBACK_OFFLINE_MOST_POPULAR_PATH: '/cashback/en-magasin/les-plus-populaires',
    CASHBACK_OFFLINE_ALPHA_PATH: '/cashback/en-magasin/alphabetique/',
    CASHBACK_OFFLINE_CATEGORY_PATH: '/cashback/en-magasin/categorie/',

    CASHBACK_EBON_MOST_POPULAR_PATH: '/cashback/bon-achat/les-plus-populaires',
    CASHBACK_EBON_ALPHA_PATH: '/cashback/bon-achat/alphabetique/',
    CASHBACK_EBON_CATEGORY_PATH: '/cashback/bon-achat/categorie/',

    EBON_VALIDATION_PATH: '/bon-achat/validation',
    EBON_CONFIRMATION_PATH: '/selection-bons-d-achat/confirmation',
    EBON_ERROR_PATH: '/selection-bons-d-achat/error',
    EBON_DOWNLOAD_BILL_PATH: '/gift-card-selection/order/bill',

    REDUCTION_MOST_POPULAR_PATH: '/reduction/les-plus-populaires',
    REDUCTION_ALPHA_PATH: '/reduction/alphabetique/',
    REDUCTION_CATEGORY_PATH: '/reduction/categorie/',

    ALPHA_PATH: 'alphabetique',
    CATEGORY_PATH: 'categorie',
    MOST_POPULAR_PATH: 'les-plus-populaires',

    NOT_FOUND_PATH: '/404'
};

export const PATH = FR;



// WEBPACK FOOTER //
// ./src/constants/path.js